export const genders = [
  { id: 'Male', name: 'Male' },
  { id: 'Female', name: 'Female' },
]

// Says why the url just typed went away - cleared on a new contact, put back on an edited one,
// so "reverted" covers both. Worded to match
// People::PersonMatch::AcceptedMatch::DUPLICATE_PERSON_MESSAGE.
export const PERSON_TAKEN_AT_FIRM_MESSAGE =
  'This person already has a contact at this firm, so the LinkedIn Url was reverted'

export const nameSuffixes = [
  {id: "Sr.", name: "Sr."},
  {id: "Jr.", name: "Jr."},
  {id: "II", name: "II"},
  {id: "III.", name: "III"},
  {id: "IV", name: "IV"},
  {id: "V", name: "V"},
  {id: "VI", name: "VI"},
  {id: "VII", name: "VII"},
]
